import React, { } from 'react';
import { useDispatch } from 'react-redux';
import { Label } from 'view/component/Label/Label';
import { Conteudo } from 'view/section/Conteudo/Conteudo';
import * as Yup from 'yup';
import { Botao, BotaoFlat } from '../Botao/Botao';
import { MensagemErro } from '../Formulario/MensagemErro/MensagemErro';
import { UnidadeSelect } from '../UnidadeSelect/UnidadeSelect';
import { Form, Formik } from 'formik';
import { ServidorField } from '../ServidorField/ServidorField';
import PermisaoSelect from '../PermissaoSelect/PermissaoSelect';
import { addMembroUnidade, fetchMembrosUnidades, updateMembroUnidadeById } from 'store/MembroUnidade/membroUnidadeSlice';
import { Input } from '../Input/Input';

interface MembroUnidadeFormProps {
  initialValues?: any;
  onSubmit?: () => void;
  onClose?: () => void;
}


const MembroUnidadeForm: React.FC<MembroUnidadeFormProps> = ({ initialValues, onClose }) => {
  const dispatch = useDispatch();
  const isEditing = !!initialValues.id;


  const validationSchema = Yup.object().shape({
    idInstitucional: Yup.string().required('Campo obrigatório'),
    idUnidade: Yup.string().required('Campo obrigatório'),
    idPapelMembro: Yup.string().required('Campo obrigatório'),
  });

  const formattedDataInicio = initialValues.dataInicio ? initialValues.dataInicio.format('YYYY-MM-DD') : '';
  const formattedDataFim = initialValues.dataFim ? initialValues.dataFim.format('YYYY-MM-DD') : '';

  return (
    <Conteudo>
      <Formik
        initialValues={{
          ...initialValues,
          dataInicio: formattedDataInicio,
          dataFim: formattedDataFim
        }}
        validationSchema={validationSchema}
        onSubmit={(values) => {

          const formattedDataInicioUTC = values.dataInicio ? `${values.dataInicio}T00:00:00+00:00` : '';
          const formattedDataFimUTC = values.dataFim ? `${values.dataFim}T00:00:00+00:00` : '';
          const uptValues = {
            ...values,
            dataInicio: formattedDataInicioUTC,
            dataFim: formattedDataFimUTC
          }

          console.log("formattedDataInicio2: ", formattedDataInicioUTC);

            (async () => {
              if (isEditing) {
                await dispatch(updateMembroUnidadeById(uptValues));
              } else {
                await dispatch(addMembroUnidade(uptValues));
              }
              dispatch(fetchMembrosUnidades());
            })();

          if (onClose) {
            onClose();
          }
        }}
      >
        <Form>
          <Label htmlFor="idUsuario">Usuário</Label>
          <ServidorField name="idInstitucional" inputId="idInstitucional" />
          <MensagemErro name="idInstitucional" />

          <Label htmlFor="idUnidade">Unidade associada</Label>
          <UnidadeSelect name="idUnidade" inputId="idUnidade" unidades={[]} />
          <MensagemErro name="idUnidade" />

          <Label htmlFor="idPapelMembro">Papel</Label>
          <PermisaoSelect name="idPapelMembro" inputId="idPapelMembro" />

          <Label htmlFor="dataInicio">Data Início</Label>
          <Input name="dataInicio" id="dataInicio" type="date" />

          <Label htmlFor="dataFim">Data Fim</Label>
          <Input name="dataFim" id="dataFim" type="date" />

          <footer>
            <Botao>{isEditing ? "Atualizar" : "Salvar"}</Botao> <BotaoFlat tipo="cancel" onClick={onClose}>Cancelar</BotaoFlat>
          </footer>
        </Form>
      </Formik>
    </Conteudo>

  );
};

export default MembroUnidadeForm;

